import { TireSearch } from "../components/TireSearch"



export const Home = () => {

    return (
        <div className="w-full">
            <header
                className="min-h-[400px] bg-cover flex justify-center items-center relative px-4 pb-10 pt-[100px] bg-top"
                style={{ backgroundImage: "url(/images/header-banner.jpg)" }}
            >
                <div className="absolute inset-0 bg-black bg-opacity-70" />
                <div className="z-10 text-center text-white px-4 space-y-2 max-w-2xl w-full">
                    <h1 className="text-4xl md:text-5xl font-bold mb-4 !leading-tight">
                        Get the right fit.
                        <br />
                        Find your <span className="text-primary">perfect tires.</span>
                    </h1>
                    <div className="mt-4">
                        <TireSearch />
                    </div>
                </div>

            </header>
            <section className="bg-gray-100 py-16">
                <div className="max-w-6xl mx-auto px-4 text-center">
                    {/* Section Title */}
                    <h2 className="text-2xl font-medium mb-12">How it works</h2>

                    {/* Steps */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        {/* Step 1 */}
                        <div className="bg-white rounded-xl shadow-lg hover:shadow-lg transition px-10 py-12">
                            <div className="flex justify-center mb-4 text-primary">
                                <span className="material-symbols-outlined text-[40px]">
                                    check_circle
                                </span>
                            </div>
                            <h3 className="text-lg font-semibold mb-2">SELECT YOUR TIRES</h3>
                            <p className="text-gray-600 text-sm">
                                Browse from top brands and choose the right tire based on your
                                vehicle, size, or driving needs.
                            </p>
                        </div>

                        {/* Step 2 */}
                        <div className="bg-white rounded-xl shadow-lg hover:shadow-lg transition px-10 py-12">
                            <div className="flex justify-center mb-4 text-primary">
                                <span className="material-symbols-outlined text-[40px]">
                                    calendar_check
                                </span>
                            </div>
                            <h3 className="text-lg font-semibold mb-2">SCHEDULE APPOINTMENT</h3>
                            <p className="text-gray-600 text-sm">
                                Once you've found your tires, book your preferred service slot. We
                                work around your busy schedule.
                            </p>
                        </div>

                        {/* Step 3 */}
                        <div className="bg-white rounded-xl shadow-lg hover:shadow-lg transition px-10 py-12">
                            <div className="flex justify-center mb-4 text-primary">
                                <span className="material-symbols-outlined text-[40px]">
                                    build
                                </span>
                            </div>
                            <h3 className="text-lg font-semibold mb-2">IN-STORE INSTALLATION</h3>
                            <p className="text-gray-600 text-sm">
                                Drive in at your scheduled time, and our professionals will
                                install your new tires with precision and care.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-primary text-white py-16">
                <div className="max-w-6xl mx-auto px-4 text-center">
                    {/* Section Title */}
                    <h2 className="text-2xl font-medium mb-12">
                        Save time, money & <span className="font-medium">hassle</span>
                    </h2>

                    {/* Features */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
                        {/* 1. Get the right price */}
                        <div>
                            <div className="flex justify-center mb-4">
                                <span className="material-symbols-outlined text-[80px]">
                                    savings
                                </span>
                            </div>
                            <h3 className="text-lg font-semibold mb-2">Get the right price.</h3>
                            <p className="text-sm text-white/90 max-w-xs mx-auto">
                                No hidden costs, no confusion — just clear and honest pricing.
                                Compare top tire brands and get the best deal that fits your
                                budget and your vehicle.
                            </p>
                        </div>

                        {/* 2. Hassle-Free Installation */}
                        <div>
                            <div className="flex justify-center mb-4">
                                <span className="material-symbols-outlined text-[80px]">
                                    build_circle
                                </span>
                            </div>
                            <h3 className="text-lg font-semibold mb-2">
                                Hassle-Free Installation.
                            </h3>
                            <p className="text-sm text-white/90 max-w-xs mx-auto">
                                Choose a convenient time, and our professionals will handle
                                everything — quickly and efficiently we make the whole process
                                effortless for you.
                            </p>
                        </div>

                        {/* 3. We Take Care of Everything */}
                        <div>
                            <div className="flex justify-center mb-4">
                                <span className="material-symbols-outlined text-[80px]">
                                    thumb_up
                                </span>
                            </div>
                            <h3 className="text-lg font-semibold mb-2">
                                We Take Care of Everything.
                            </h3>
                            <p className="text-sm text-white/90 max-w-xs mx-auto">
                                Sit back while we handle all the details. From selecting the right
                                tire to fitting and after-service checks, we ensure a smooth and
                                effortless experience.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}